module.exports = __webpack_public_path__ + "img/MaterialEditor.b167c5e7.png";